import { LayerDefinition } from './types';

export const bortleDefinition: LayerDefinition = {
  id: 'bortle',
  name: 'Light Pollution (Bortle Scale)',
  category: 'space_astronomy',
  categoryLabel: 'Astronomical & Night Sky',
  icon: '✨',
  description: 'High-resolution night sky brightness and artificial light radiance map classified by the Bortle Dark-Sky Scale (Class 1-9).',
  sourceModels: ['VIIRS Day/Night Band Satellite Radiance', 'World Atlas of Artificial Night Sky Brightness'],
  outputModels: ['Bortle radiance .pmtiles (Class 1 Pristine to Class 9 Inner-City)']
};

export default bortleDefinition;
